// Copyright (c) 2019 Celadon Development LLC, All rights reserved.
// Author Yana Sidorova <yana.sidorova@celadon.ae>
import GlobalStyles from '../../../../config/styles';

const styles = ({
  mainContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    minWidth: 200,
    color: GlobalStyles.color.COLOR_GREY,
    maxWidth: 300,
  },
  textBold: {
    fontFamily: GlobalStyles.fonts.FONT_ANLTP_BOLD,
    marginRight: 5,
  },
  boldSmallText: {
    display: 'flex',
    fontFamily: GlobalStyles.fonts.FONT_ANLTP_BOLD,
    fontSize: GlobalStyles.fonts.FONT_SIZE_SMALL,
    marginBottom: 10,
  },
  regularSmallText: {
    display: 'flex',
    fontFamily: GlobalStyles.fonts.FONT_ANLTP_REGULAR,
    fontSize: GlobalStyles.fonts.FONT_SIZE_SMALL,
  },
  timeContainer: {
    display: 'flex',
  },
  marginRight: {
    marginRight: 5,
  }
});

export default styles;
